import * as React from 'react';
export const cartesbancairesSvg = React.forwardRef(
  function cartesbancairesSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M15 0a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h14ZM4.955 5.1c-.572 0-1.083.129-1.51.364a2.538 2.538 0 0 0-1.003 1.004 3.1 3.1 0 0 0-.364 1.51c0 .572.13 1.082.364 1.508.236.426.577.769 1.003 1.004a3.1 3.1 0 0 0 1.51.364h.541c.572 0 1.083-.128 1.509-.364a2.54 2.54 0 0 0 1.004-1.004 3.04 3.04 0 0 0 .36-1.337H5.323v-.344H8.37a3.038 3.038 0 0 0-.36-1.337 2.54 2.54 0 0 0-1.004-1.004c-.426-.235-.937-.363-1.509-.363h-.54Zm3.762 5.607h4.082a1.28 1.28 0 0 0 0-2.558H8.717v2.558Zm0-2.902h4.082a1.279 1.279 0 1 0 0-2.557H8.717v2.557Z',
      }),
    );
  },
);
cartesbancairesSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var cartesbancaires = {
  category: 'paymentmethod',
  colorable: true,
  name: 'cartesbancaires',
  svg: cartesbancairesSvg,
};
